<template>
    <form
      id="app"
      @submit="checkForm"
      action=""
      method="post"
      class="h-100"
      :class="[loading ? 'loading' : '']"
      data-gtm-form-interact-id="0"
    >
      <h2 class="step-title">{{ __('trads.Choose-your-plan') }}</h2>
  
      <div v-if="Object.keys(errors).length">
        <div
          class="alert alert-danger"
          role="alert"
          v-for="(error, index) in errors"
          :key="index"
        >
          <strong>{{ error }}</strong>
        </div>
      </div>
  
      <div class="billing-plan">
        <div class="segmented-control plan-segment" style="min-height: 200px;">
          <div v-for="(plan, index) in $parent.plans" :key="plan.id">
            <input
              type="radio"
              :value="plan.id"
              :id="'p_' + plan.id"
              name="segmented-control"
              :data-gtm-form-interact-field-id="index"
              v-model="selectedPlan"
            />
  
            <label :for="'p_' + plan.id">
              <div class="round-selector top-selector"></div>
  
              <span class="badge badge-info save-money" v-if="plan.highlighted">
                <h5 v-text="__('trads.percent-saved', { percent: 50 })"></h5>
              </span>
  
              <div class="plan-sub text-left">
                <div class="period" v-text="plan.period"></div>
                <div class="billing-time" v-text="plan.time"></div>
              </div>
              <div class="right-area" v-text="plan.summary"></div>
            </label>
          </div>
        </div>
        <h3 v-text="__('trads.The-resiliation-is-possible')"></h3>
      </div>
  
      <button
        type="submit"
        class="d-flex justify-content-center align-items-center mt-4 btn btn-authent btn-lg btn-block cg-submit"
      >
        {{ this.__('trads.Continue') }}
        <img class="next-arrow" src="/img/style/next-arrow.svg" />
      </button>
    </form>
  </template>
  
  <script>
  export default {
    props: ['selected'],
    data() {
      return {
        loading: null,
        errors: {},
        selectedPlan: false,
      };
    },
    beforeMount() {
      this.selectedPlan = this.selected ? this.selected : this.$parent.defaultPlan;
    },
    methods: {
      checkForm(e) {
        e.preventDefault();
  
        this.loading = true;
        this.errors = {};
  
        if (this.selectedPlan) {
          return this.$parent.nextStep();
        }
  
        this.loading = false;
        this.errors['plans'] = this.__('trads.please-select-plan');
      },
    },
    watch: {
      selectedPlan(newSelected) {
        this.$root.$emit('selectedPlan', newSelected);
      },
    },
  };
  </script>
  
  <style>
  </style>
  